import { useTLang } from 'intl/intl';

export function useMozartButtonLang() {
  return {
    label: useTLang({ id: 'notification.mozart.018' }),
  };
}
